import type { Paragraphs as ParagraphsType } from 'types/capi/content';

import Paragraph from './Paragraph';
import Text from './Text';

type Props = {
  paragraphs: ParagraphsType;
};

const Paragraphs = ({ paragraphs }: Props) => {
  return (
    <div className="flex flex-col gap-5">
      {paragraphs.items?.map(({ content }, pIndex) => {
        return (
          <Paragraph key={`paragraph-${pIndex}`}>
            {content.items.map((item, index) => {
              return <Text key={`text-${index}`} item={item} />;
            })}
          </Paragraph>
        );
      })}
    </div>
  );
};

export default Paragraphs;
